import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import tw from 'twin.macro';

import AppStoreIcon from '@/assets/images/icons/AppStoreIcon';
import BigCheckIcon from '@/assets/images/icons/BigCheckIcon';
import GooglePlayIcon from '@/assets/images/icons/GooglePlayIcon';
import { BigTitle, StepContentWrapper, SubTitle } from '@/components';

const steps = [
  '1. Зарегистрируйтесь в приложении Tradernet.Global, пройдите комплаенс-проверку и откройте брокерский счёт.',
  '2. По результатам открытия брокерского счета будет проведена повторная комплаенс-проверка на стороне банка.',
  '3. В случае прохождения проверки ожидайте персональную ссылку на видео-собеседование от сотрудников банка. Ожидание может занять до 4 дней.',
  'Процесс выпуска цифровой карты осуществляется через комплаенс-проверку от Freedom Broker и Freedom Bank.'
];

function PendingPage() {
  const location = useLocation();
  const [card, setCard] = useState(null);

  useEffect(() => {
    setCard(location.pathname.split('/')[1]);
  }, [location]);

  return (
    <>
      <StepContentWrapper twStyles={tw`text-center flex flex-col gap-5 mb-5 pb-[48px] items-center`}>
        <div tw='w-[100px] h-[100px] flex items-center justify-center rounded-full mx-auto bg-green-alpha sm:mt-[48px] mt-[30px]'>
          <BigCheckIcon />
        </div>
        <BigTitle
          text={
            card === 'deposit-card' ? (
              <span>
                Открыть и получить Deposit card можно в <span tw='text-green'>отделениях банка</span>
              </span>
            ) : (
              <span>Спасибо, ваша заявка на карту инвестора принята</span>
            )
          }
          twStyle={tw`max-w-[400px] `}
        />
        {card === 'invest-card' && (
          <div tw='text-left flex flex-col gap-5 py-5 sm:px-10 px-5'>
            <SubTitle text={'Что нужно сделать дальше:'} variant={'bold'} />
            <InfoContainer />
          </div>
        )}
      </StepContentWrapper>
      {/* {card === 'deposit-card' && (
        // <StepContentWrapper twStyles={tw`flex flex-col gap-5 mb-5 p-10`}>
        //   <Title text={'Цифровая карта инвестора'} variant='bold' />
        //   <InfoContainer />
        // </StepContentWrapper>
      )} */}
    </>
  );
}

export default PendingPage;

const InfoContainer = () => {
  return (
    <>
      <ul>
        {steps?.map(item => (
          <li tw='text-secondary' key={item}>
            {item}
          </li>
        ))}
      </ul>
      <SubTitle text={'Скачать приложение Tradernet.Global:'} variant={'bold'} twStyle={tw`mt-5`} />
      <div tw='flex sm:flex-row flex-col gap-5'>
        <AppButton href='https://play.google.com/store/apps/details?id=com.bpc.internetBanking&pli=1' target='_blank'>
          <GooglePlayIcon />
        </AppButton>
        <AppButton href='https://apps.apple.com/kz/app/mykassa2/id951692404' target='_blank'>
          <AppStoreIcon />
        </AppButton>
      </div>
    </>
  );
};

const AppButton = ({ children, ...props }) => {
  return (
    <a tw='h-[48px] rounded-[8px] bg-black flex items-center justify-center px-10' {...props}>
      {children}
    </a>
  );
};
